import { connect } from 'react-redux';
import AggregationInfoChart from './AggregationInfoChart';
import { createStructuredSelector } from 'reselect';
import { getAggregationInfoChart } from './AggregationInfoChart.selectors';
import { actions } from './AggregationInfoChart.actions';

const mapStateToPropsSelectors = createStructuredSelector({
    item: getAggregationInfoChart
});

const AggregationInfoChartComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.aggregation.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            init: actions.initAggregationInfoChart
        };
    }
)(AggregationInfoChart);

export default AggregationInfoChartComponent;
